"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable: no-unused-expression
const browser_1 = require("./browser");
const cookies_1 = require("./cookies");
const generateClientId_1 = require("./generateClientId");
const helpers_1 = require("./helpers");
const paramKeys_1 = require("./paramKeys");
const Gc = (results, b, index) => {
    const d = [];
    let e = [];
    let g;
    for (const res of results) {
        res.H[index] === b ? d.push(res) : undefined === g || res.H[index] < g ? (e = [res],
            g = res.H[index]) : res.H[index] === g && e.push(res);
    }
    return 0 < d.length ? d : e;
};
const na = (cookieValues, domain, path) => {
    if (!cookieValues || 1 > cookieValues.length) {
        helpers_1.default.trace(12);
    }
    else {
        const kd = /^amp-[\w.-]{22,64}$/;
        const results = [];
        for (const cookieValue of cookieValues) {
            const tokens = cookieValue.split('.');
            const left = tokens.shift();
            let res;
            if (('SEA1' === left || '1' === left) && 1 < tokens.length) {
                let right;
                (right = tokens.shift().split('-'),
                    1 === cookieValue.length && (right[1] = '1'),
                    right[0] *= 1,
                    right[1] *= 1,
                    res = {
                        H: cookieValue,
                        s: tokens.join('.'),
                    });
            }
            else {
                res = kd.test(cookieValue) ? {
                    H: [0, 0],
                    s: cookieValue,
                } : undefined;
            }
            res && results.push(res);
        }
        if (1 === results.length) {
            return helpers_1.default.trace(13), results[0].s;
        }
        if (0 === results.length) {
            helpers_1.default.trace(12);
        }
        else {
            helpers_1.default.trace(14);
            let d = Gc(results, helpers_1.default.stripLeadingDot(domain).split('.').length, 0);
            if (1 === d.length) {
                return d[0].s;
            }
            d = Gc(d, browser_1.default.countPathSegments(path), 1);
            1 < d.length && helpers_1.default.trace(41);
            return d[0] && d[0].s;
        }
    }
};
const getPrefix = (params, key) => {
    const encodedValue = cookies_1.encodeCookieText(params.getOrEmpty(key));
    let domainTokenLen = '' + helpers_1.default.stripLeadingDot(params.getOrEmpty(paramKeys_1.default.CookieDomain)).split('.').length;
    const pathLen = browser_1.default.countPathSegments(params.getOrEmpty(paramKeys_1.default.CookiePath));
    if (pathLen > 1) {
        domainTokenLen += '-' + pathLen;
    }
    return key ? ['SEA1', domainTokenLen, encodedValue].join('.') : '';
};
const init = (params, entityKey) => {
    let hasCookie = false;
    const cookieValues = cookies_1.getCookieValues(params.getOrEmpty(paramKeys_1.default.CookieName));
    let cookieValue = na(cookieValues, params.getOrEmpty(paramKeys_1.default.CookieDomain), params.getOrEmpty(paramKeys_1.default.CookiePath));
    if (!cookieValue) {
        const cookieDomain = params.getOrEmpty(paramKeys_1.default.CookieDomain);
        const domain = browser_1.default.getNormalizedHost(browser_1.default.getDocument());
        const hashedResult = cookies_1.findCookieValueByHash('__utma', cookieDomain, domain);
        if (hashedResult !== undefined) {
            helpers_1.default.trace(10);
            cookieValue = hashedResult.O[1] + '.' + hashedResult.O[2];
        }
        else {
            cookieValue = undefined;
        }
    }
    cookieValue && (hasCookie = true);
    let d;
    if (cookieValue && !params.get(paramKeys_1.default.CookieUpdate)) {
        const cookieNum = Number(cookieValue[1]);
        const m = cookieValue.split('.');
        if (2 !== m.length) {
            d = false;
        }
        else if (cookieNum) {
            const e = params.getNumber(paramKeys_1.default.CookieExpires);
            d = cookieNum + e < (new Date()).getTime() / 1E3;
        }
        else {
            d = false;
        }
    }
    if (d) {
        cookieValue = undefined;
    }
    if (cookieValue) {
        params.data.set(paramKeys_1.default.StoredClientId, cookieValue);
        params.data.set(paramKeys_1.default.EntityKey, cookieValue);
    }
    if (entityKey) {
        helpers_1.default.trace(9);
        params.data.set(paramKeys_1.default.EntityKey, browser_1.default.encodeValue(entityKey));
    }
    if (!params.get(paramKeys_1.default.EntityKey)) {
        helpers_1.default.trace(8);
        params.data.set(paramKeys_1.default.EntityKey, generateClientId_1.default());
    }
    set(params);
    return hasCookie;
};
const set = (params) => {
    if (params.get(paramKeys_1.default.CookieUpdate)
        || params.getOrEmpty(paramKeys_1.default.StoredClientId) !== params.getOrEmpty(paramKeys_1.default.EntityKey)) {
        const cookieExpires = 1E3 * params.getNumber(paramKeys_1.default.CookieExpires);
        const e = getPrefix(params, paramKeys_1.default.EntityKey);
        if (e) {
            const cookieName = params.getOrEmpty(paramKeys_1.default.CookieName);
            const g = browser_1.default.normalizePath(params.getOrEmpty(paramKeys_1.default.CookiePath));
            const ca = helpers_1.default.stripLeadingDot(params.getOrEmpty(paramKeys_1.default.CookieDomain));
            cookies_1.setCookie(cookieName, e, g, ca, cookieExpires) && (this.hasCookie = true);
        }
    }
};
exports.default = {
    init,
    set,
};
